import { Link } from 'expo-router';

import { ProjectItem } from '@/components/project-item';
import { Container } from '@/components/container';

export default function App() {
  return (
    <Container>
      <div className="mt-8 md:mt-36 space-y-6 flex flex-col justify-center flex-1 text-subtle">
        <p>Ideas always come from many small connections.</p>
        <p>
          Everything happens by observing what others create. This blog was born
          as an output of ideas that came to me from looking at projects and
          other blogs.
        </p>
      </div>

      <div className="mt-14">
        <h2 className="text-2xl font-semibold text-white mb-2">Inspirations</h2>
        <ProjectItem
          title="Evan Bacon's Portfolio"
          href="https://evanbacon.dev"
          description="I think this is the first available blog built on top of expo-router. Besides being a really useful blog content-wise, the shape of it really inspired me to recreate my blog entirely on top of Expo & React Native."
        />
        <ProjectItem
          title="Emil Kowalski's Blog"
          href="https://emilkowal.ski"
          description="Emil is a tremendous source of inspiration. His way of presenting articles by adding interactivity as an ingredient was a major factor for me in trying to recreate my blog."
        />
        <ProjectItem
          title="Maxime Heckel's Blog"
          href="https://blog.maximeheckel.com"
          description="The quality of Maxime Heckel's blog is out of this world. The 👋 you see on the home page is inspired by his home page. The quality of his content, on the other hand, is an ongoing reference."
        />
        <ProjectItem
          title="Reanimated Docs"
          href="https://docs.swmansion.com/react-native-reanimated/"
          description="The whole Reanimated Docs is a source of inspiration. I love the way it's explained and how the animations are implemented."
        />
      </div>
      <div className="mt-14">
        <h2 className="text-2xl font-semibold text-white mb-2">Mentions</h2>
        <ProjectItem
          title="William Candillon"
          href="https://www.youtube.com/@wcandillon"
          description="If you want to see something magical, simply go to William Candillon's Youtube Channel. I started and continue to develop animations by obsessively watching what he creates. As if that was not enough, together with Christian Falch, he co-created React Native Skia."
        />
      </div>

      <Link href="/" className="items-center mt-8">
        <p className="font-semibold underline underline-offset-2 text-subtle">
          Back to Home
        </p>
      </Link>
    </Container>
  );
}
